module.exports = __webpack_public_path__ + "static/media/img_Benchmarking304.f5299ca0.png";